import { environment } from '@environments/environment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';
import * as master from '../../assets/master.json';
import {MatTableDataSource} from '@angular/material/table';
import {MatTableModule} from '@angular/material/table';
import { formatDate } from '@angular/common';
import { PaymentService } from '@app/_services/payment.service';

export interface masters {
  srno:number;
  subcode: string;
  subname: string;
  marksheetfee: number;
  arearFee: number;
  lateFee: number;
}

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html',
  styleUrls: ['./fee-details.component.less']
})
export class FeeDetailsComponent implements OnInit {

  form: FormGroup;
  JSON;
  console;
  isgPay_url:string;
  todayDate:Date;
  total:any = 0;
  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  paymentDetails:any='';
  json:any= master;
  source:any;
  amountObj:any;
  amount:any;
  installmentNumberList:any;
  feeDetailsList:any[]=[];
  feeTypeAmount:any;
  standardList:any[]=[];
  standardListObj:any[]=[];
  feeType:any;
  totalFee:any;
  submitted = false;
  initialCap: any;
  captcha:any;
  standard:any;
  installmentNumber:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  myDIV: Boolean = false ;
  totalDisabled:boolean=true;
  masterData:any;
  dataSource:any;
  toDate:any;
  split;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService
  ) {
    this.JSON=JSON;
    this.isgPay_url = paymentService.isgPay_url;
    this.commonUtility = this.paymentService.commonUtility;
    this.masterData = master;
    this.console = console;
   
   }
   maxValue(event)
   {
    if(event.target.value && event.target.max)
    {
      if((event.which != 8 && event.which != 46 && event.which != 37 &&event.which != 39 &&event.which != 9))
      {
          if(event.target.value.length>(<number>event.target.max-1))
        {
          event.preventDefault();
        }
      }
    }
   }

  ngOnInit(): void {
    this.todayDate = new Date();

  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({
        registrationNo: ["",[Validators.required,Validators.pattern("^[a-zA-Z0-9- ]+$")]],
        studentName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        dob: ["",[Validators.required]],
        fatherName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        mobileNo: ["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
        emailId: ["",Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")],
        courseName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        academicYear: ["",[Validators.required,Validators.pattern("^[0-9- ]+$")]],
        session: ["",[Validators.required,Validators.pattern("^[a-zA-Z0-9- ]+$")]],
        courseFee: ['0',Validators.pattern("^[0-9]+$")],
        transportationFee: ['0',Validators.pattern("^[0-9]+$")],
        examinationFee: ['0',Validators.pattern("^[0-9]+$")],
        hostelFee: ['0',Validators.pattern("^[0-9]+$")],
        otherFee: ['0',Validators.pattern("^[0-9]+$")],
        otherFeeDetails: ['',Validators.pattern("^[a-zA-Z0-9- ]+$")],
        totalFee: [{value: '', disabled:true}],
        captcha: ["", [Validators.required]]

      });
      this.Cap();

  }

  get f()
 { return this.form.controls; }

 redirectHome()
 {
   this.router.navigate(['/']);
 }

  Submit():void{

    var routeUrl;
    this.submitted = true;    
    if (this.form.invalid || (!this.ValidCaptcha())) {
      return;
    }

    if(this.form.controls.totalFee.value ==0){
      this.commonUtility.alertMsg('Total Fee Should Not be Zero , Please Enter Atleast One Fee Details','',false);
    }
    else{


    let req = {
        'registrationNumber':this.form.controls.registrationNo.value.toString(),
        'studentName' :this.form.controls.studentName.value.toString(),
        'dob' :this.form.controls.dob.value.toString(),
        'fatherName' :this.form.controls.fatherName.value.toString(),
        'mobileNo' :this.form.controls.mobileNo.value.toString(),
        'emailId' :this.form.controls.emailId.value.toString(),
        'courseName':this.form.controls.courseName.value.toString(),
        'academicYear':this.form.controls.academicYear.value.toString(),
        'session':this.form.controls.session.value.toString(),
        'courseFee':this.form.controls.courseFee.value.toString(),
        'transportationFee':this.form.controls.transportationFee.value.toString(),
        'examinationFee':this.form.controls.examinationFee.value.toString(),
        'hostelFee':this.form.controls.hostelFee.value.toString(),
        'otherFee':this.form.controls.otherFee.value.toString(),
        'otherFeeDetails':this.form.controls.otherFeeDetails.value.toString(),
        'totalFee':this.form.controls.totalFee.value.toString(),
        'source': 'SPINTRONIC',
        "captcha":this.form.controls.captcha.value

        
    }


    const encodedCaptcha = btoa(this.form.controls.captcha.value);

    this.paymentService.submitSpintronicDetails(req,encodedCaptcha).subscribe(res =>  {
      if(res.body.statusCode === "00000")
      {

       this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
       this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
       this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
       this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
       this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
       this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

       this.EncDataField  	= res.body.data.fields.EncData;
       this.MerchantIdField = res.body.data.fields.MerchantId;
       this.BankIdField = res.body.data.fields.BankId;
       this.TerminalIdField = res.body.data.fields.TerminalId ;
       this.VersionField = res.body.data.fields.Version ;
       this.txnForm.nativeElement.submit();


      }
      else{
       this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
       this.loading = false;
            },(error)=>{  this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
      )
     }
    }


  onSubmit(): void
{

}

getTotal() {
  this.totalFee
  let courseFee = this.form.get('courseFee').value;
  let transportationFee = this.form.get('transportationFee').value;
  let examinationFee = this.form.get('examinationFee').value;
  let hostelFee = this.form.get('hostelFee').value;
  let otherFee = this.form.get('otherFee').value;
  this.totalFee =0;
  if(courseFee)
  {
    this.totalFee = Number(this.totalFee +parseInt(courseFee));
  }
  if(transportationFee)
  {
    this.totalFee= Number(this.totalFee +parseInt(transportationFee));
  }
  if(examinationFee)
  {
    this.totalFee = Number(this.totalFee +parseInt(examinationFee));
  }
  if(hostelFee)
  {
    this.totalFee= Number(this.totalFee +parseInt(hostelFee));
  }
  if(otherFee)
  {
    this.totalFee = Number(this.totalFee +parseInt(otherFee));
  }
  
    if(Number(this.totalFee)>0)
    { this.totalDisabled=false;

    }
    else{
      this.totalDisabled=true;
    }
    console.log(" this.totalDisabled : ");
    console.log(this.totalDisabled);
    console.log(Number(this.totalFee)>Number(0));
    this.form.updateValueAndValidity()

    this.form.controls.totalFee.setValue(this.totalFee);
    this.form.controls.totalFee.updateValueAndValidity();

}

hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }

    
    ValidCaptcha(){
      let str1=this.initialCap
      let str2=this.form.get('captcha').value;
      if(str2.toUpperCase()!="") {
      if(str1 == str2.toUpperCase()){
        this.form.controls['captcha'].setErrors(null);
        return true;
      }else{
        this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
        return false;
      }
      }
      else {
        this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
      }
    }
  
    Cap() {
      let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
       var apl1 = alpha[Math.floor(Math.random() * 36)];
       var apl2 = alpha[Math.floor(Math.random() * 36)];
       var apl3 = alpha[Math.floor(Math.random() * 36)];
       var apl4 = alpha[Math.floor(Math.random() * 36)];
       var apl5 = alpha[Math.floor(Math.random() * 36)];
       var apl6 = alpha[Math.floor(Math.random() * 36)];
       this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;
  
      }


}
 